import { DASHBOARD_ROUTES } from "./dashboardRoutes";
import React, { useRef } from "react";
import "./ChooseState.css";
import { useNavigate } from "react-router-dom";
import LogoIcon from "../assets/images/SliderLogo.png";
import starIcon from "../assets/images/bookmark.png";
import useDashboardRowDrag from "./useDashboardRowDrag";

const MAX_VISIBLE_EXAMS = 4;

const FavoriteExamSkeleton = () => (
  <div className="state-card dashboard-skeleton dashboard-collection-skeleton" data-testid="dashboard-collection-skeleton" aria-hidden="true">
    <span className="dashboard-collection-skeleton__badge" />
    <span className="dashboard-collection-skeleton__details">
      <span className="dashboard-collection-skeleton__title" />
      <span className="dashboard-collection-skeleton__subtitle" />
    </span>
  </div>
);

const FavoriteExam = ({ exams = [], isLoading = false, error = "" }) => {
  const navigate = useNavigate();
  const rowRef = useRef(null);
  useDashboardRowDrag(rowRef);
  const visibleExams = exams.slice(0, MAX_VISIBLE_EXAMS);

  return (
    <section className="quick-action dashboard-collection-section myexams-block" aria-labelledby="favorite-exam-title">
      <div className="dashboard-states">
          <div className="quick-action__header mobile-action-header">
            <h2 id="favorite-exam-title" className="quick-action__title">
              Favorite Exam
            </h2>

            <div className="quick-action__actions mobile-action">
              {!isLoading ? (
                <>
                  <button
                    type="button"
                    className="quick-action__add-state"
                    aria-label="Add Exam"
                    onClick={() => navigate(DASHBOARD_ROUTES.examCategories)}
                  >
                    <span className="quick-action__add-icon">
                      <i className="fa-solid fa-plus"></i>
                    </span>

                    <span className="quick-action__add-text">Add Exam</span>
                  </button>

                  <button
                    type="button"
                    className="quick-action__see-all"
                    onClick={() => navigate(DASHBOARD_ROUTES.examCategories)}
                  >
                    See All
                  </button>
                </>
              ) : (
                <>
                  <span className="dashboard-skeleton dashboard-collection-skeleton__add" aria-hidden="true" />
                  <span className="dashboard-skeleton dashboard-collection-skeleton__see-all" aria-hidden="true" />
                </>
              )}
            </div>
          </div>

        {!isLoading && error ? <p className="choose-state__status choose-state__status--error">{error}</p> : null}
        {!isLoading && !error && visibleExams.length === 0 ? (
          <p className="choose-state__status">No favorite exams available.</p>
        ) : null}

        <div ref={rowRef} className="choose-state__gridn dashboard-drag-row" role="region" aria-label="Favorite Exam cards" aria-busy={isLoading} tabIndex={0}>
          {isLoading ? Array.from({ length: MAX_VISIBLE_EXAMS }).map((_, index) => (
            <div key={index} aria-hidden="true">
              <FavoriteExamSkeleton />
            </div>
          )) : null}
          {!isLoading && !error ? visibleExams.map((item) => (
              <div key={item.md_exams_id}>
                <div className="state-card">
                  <img src={item.exam_image} className="state-bg" alt={item.exam_name} />

                  <div className="state-badge">
                    <img src={LogoIcon} alt="" />
                  </div>

                  {Number(item.is_favourite) === 1 ? (
                    <div className="state-star">
                      <img src={starIcon} alt="Favorite exam" />
                    </div>
                  ) : null}

                  {Number(item.is_user_exam) === 1 ? (
                    <div className="state-tick">
                      <i className="fa-solid fa-check"></i>
                    </div>
                  ) : null}

                  <div className="state-content">
                    <h5>{item.exam_name}</h5>
                    {item.state_name ? <p>({item.state_name})</p> : null}
                  </div>
                </div>
              </div>
            )) : null}
        </div>
      </div>
    </section>
  );
};

export default FavoriteExam;
